import { getCanonicalEmrSectionStyleOverrideKey } from 'src/mentor/components/MentorPrescriptionTemplates/components/utils/emrSectionIds'

export default function usePrintableSectionsConfig({
  emrSections,
  prescriptionViewSettings,
  prescriptionTemplateData,
}) {
  let styleOverrides = prescriptionViewSettings?.styleOverridesForPrintedEmrSections
  const templateOverrides = prescriptionTemplateData?.body?.styleOverridesForPrintedEmrSections


  emrSections?.forEach((section) => {
    const sectionId = section.id
    const canonicalSectionId = getCanonicalEmrSectionStyleOverrideKey(section)
    const templateOverride = templateOverrides?.[canonicalSectionId] || templateOverrides?.[sectionId]

    if (templateOverride) {
      styleOverrides = {
        ...styleOverrides,
        [canonicalSectionId]: {
          ...styleOverrides?.[canonicalSectionId],
          ...styleOverrides?.[sectionId],
          ...templateOverride,
        },
      }
    }
  })

  return {
    styleOverrides,
  }
}
